require('./brokerMainStocksSelector.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');

class BrokerMainStocksSelector extends React.Component {
    constructor(props) {
        super(props);

        this.getMarketOptions = this.getMarketOptions.bind(this);
        this.handleStockMarketChange = this.handleStockMarketChange.bind(this);
        this.buildMarketsDropdownLoadingSection = this.buildMarketsDropdownLoadingSection.bind(this);
        this.buildMarketsDropdownErrorState = this.buildMarketsDropdownErrorState.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
    }

    getMarketOptions() {
        const { immBrokerExchangeIndexes } = this.props;
        return immBrokerExchangeIndexes.get('indexesPlayers').toJS().map(exchangeIndex => {
            return {
                value: exchangeIndex.spcSymbol,
                label: exchangeIndex.name
            };
        });
    }

    buildMarketsDropdown() {
        const { immBrokerExchangeIndexes, selectedMarket, label } = this.props;
        const labelText = formatText(label || 'broker-mainStocksSelectorLabel');

        if (!immBrokerExchangeIndexes.get('hasBeenFetched')) {
            return;
        }

        const marketOptions = this.getMarketOptions();

        return (
            <div className="row no-outside-gutter">
                <div className="col-xs-8">
                    <OKSelect
                        label={labelText}
                        className=""
                        name="stockMarket"
                        onChange={this.handleStockMarketChange}
                        options={marketOptions}
                        value={selectedMarket}
                        searchable={false}
                    />
                </div>
            </div>
        );
    }

    buildMarketsDropdownErrorState() {
        const { immBrokerExchangeIndexes } = this.props;

        if (immBrokerExchangeIndexes.get('errorReceived')) {
            const lostConnectionFirstLine = formatText('broker-lostConnectionFirstLine');

            const retryButton = (
                <OKButton onClick={this.handleRetry}>
                    <FormattedText value="myMoneyTransactions-retry" />
                </OKButton>
            );

            return (
                <EmptyState
                    button={retryButton}
                    primaryText={lostConnectionFirstLine}
                    iconType="nointernet-wealth"
                />
            );
        }
    }

    buildMarketsDropdownLoadingSection() {
        const { immBrokerExchangeIndexes } = this.props;

        if (immBrokerExchangeIndexes.get('isFetching')) {
            return (<LoadingSection />);
        }
    }

    handleRetry() {
        this.props.requestIndexes();
    }

    handleStockMarketChange(event) {
        const selectedMarket = event.value;
        this.props.onChange({ selectedMarket });
    }

    render() {
        const marketsDropdownLoadingSection = this.buildMarketsDropdownLoadingSection();
        const marketsDropdown = this.buildMarketsDropdown();
        const marketsDropdownErrorState = this.buildMarketsDropdownErrorState();

        return (
            <div className="broker-main-stocks-selector">
                {marketsDropdownLoadingSection}
                {marketsDropdown}
                {marketsDropdownErrorState}
            </div>
        );
    }
}

BrokerMainStocksSelector.propTypes = {
    immBrokerExchangeIndexes: PropTypes.object.isRequired,
    selectedMarket: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    requestIndexes: PropTypes.func.isRequired,
    label: PropTypes.string
};

module.exports = BrokerMainStocksSelector;
